import axios from "axios";
import { urls } from "../utils/urls";

export const getMenuListData = () => {
  return axios.get(urls.getMenuList);
};


